import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps, lifecycle } from 'recompose';
import { get } from 'lodash';
import { Row, Col } from 'reactstrap';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';

import GeneratorPreview from 'components/GeneratorPreview';
import GenericCard from 'components/GenericCard';
import ReviewsLink from 'components/ReviewsLink';
import dataLayerPush from 'services/dataLayer';

import FAQs from './FAQs';
import ScheduleAssessment from './ScheduleAssessment';
import CalloutAssessment from './CalloutAssessment';
import GeneratorReviews from './GeneratorReviews';
import productImages from './images/products';
import reduxFormWithGeneratorNeedsConfig from './withReduxFormGeneratorNeedsConfig';
import { getRecommendation } from './helpers/recommendations';

const GetUrlParameter = (name) => {
  const nameClean = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${nameClean}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const Recommendations = ({ recommendations: { recommended, budget }, previousStep }) => {
  const recommendedGenerator = recommended ? (
    <GeneratorPreview
      image={productImages[recommended.imageName]}
      heading="Best Match"
      generatorData={recommended}
      showReviewsLink={!budget}
    />
  ) : (<GenericCard content="<p>Your home’s power needs would benefit from a custom solution.</p><p>Contact us today to discuss your options.</p>" />);

  const budgetGenerator = !!budget && (
    <GeneratorPreview
      image={productImages[budget.imageName]}
      heading={budget.isPortable ? 'Or, for a portable option...' : 'You may also consider...'}
      generatorData={budget}
      isPortable={budget.isPortable}
    />
  );

  const assessmentSection = (GetUrlParameter('hideContForm') === '1' ? <CalloutAssessment /> : <ScheduleAssessment />);

  const content = !budgetGenerator
    ? (
      // Single Recommendation Layout
      <Row>
        <Col xs={12} sm={6}>
          { recommendedGenerator }
        </Col>
        <Col xs={12} sm={6}>
          { assessmentSection }
        </Col>
      </Row>
    )
    : (
      // Two-recommendation layout
      <Row noGutters>
        <Col xs={12} sm={6} className="recommendations__dual">
          { recommendedGenerator }
        </Col>
        <Col xs={12} sm={6} className="recommendations__dual">
          { budgetGenerator }
        </Col>
        <Col xs={12}>
          <div className="text-center" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <ReviewsLink href="#reviews" />
          </div>
          { assessmentSection }
        </Col>
      </Row>
    );

  return (
    <div className="recommendations">
      <div className="upper-navigation is-centered">
        <button type="button" onClick={previousStep}><ChevronLeft /> Back</button>
      </div>
      <div className="recommendations__upper-content">
        <h2 className="recommendations__heading">
          Based on your estimated power needs, we think this model would be a great fit:
        </h2>
        { content }
      </div>
      <GeneratorReviews />
      <div className="recommendations__lower-content">
        <FAQs />
      </div>
    </div>
  );
};

Recommendations.propTypes = {
  recommendations: PropTypes.shape(),
  previousStep: PropTypes.func.isRequired,
};

const enhance = compose(
  reduxFormWithGeneratorNeedsConfig,
  connect(
    ({ derivedData }) => ({
      requiredWattage: get(derivedData, 'homeNeeds.totalWatts', 0),
    }),
  ),
  withProps(({ requiredWattage }) => ({
    requiredWattage,
    recommendations: getRecommendation({}, requiredWattage),
  })),
  lifecycle({
    componentDidMount() {
      const { recommendations: { recommended }, requiredWattage } = this.props;
      const payload = {
        event: 'calculator',
        wattage: requiredWattage,
        ...recommended,
      };
      dataLayerPush(payload);
    },
  }),
);

export default enhance(Recommendations);



// WEBPACK FOOTER //
// ./src/views/Home/components/Recommendations.js